import { render, staticRenderFns } from "./DashboardMap.vue?vue&type=template&id=2c6b6a23&"
import script from "./DashboardMap.vue?vue&type=script&lang=js&"
export * from "./DashboardMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports